// extracted by mini-css-extract-plugin
module.exports = {"item":"PlayersList_item__19NxC","coins":"PlayersList_coins__3iaKa"};